module.exports = __webpack_public_path__ + "static/Customer2-bf1301e95d6ff863c9b0099d704efca9.jpg";